<template>
  <div class="content">
    <template>
      <v-card
        :style="
          $vuetify.breakpoint.xs
            ? 'margin: 4px'
            : 'margin: 0 18px 0 18px'
        "
      >
        <base-loading v-if="loading" />
        <div v-else>
          <crud-list
            v-model="logs"
            :headers="headers"
            :item-class="itemRowBackground"
            :sort-by="['logged_at', 'nomeUsuario']"
            :sort-desc="[true, false]"
            :slots="['item.status']"
            :actions="actions"
            export-pdf-xlsx
          >
            <template slot="datas">
              <v-col
                cols="6"
              >
                <data-field
                  v-model="data_inicial"
                  :label="'Data Inicial'"
                  :data-max="data_final"
                  @set="handleDataFilter()"
                />
              </v-col>
              <v-col
                cols="6"
              >
                <data-field
                  v-model="data_final"
                  :label="'Data Final'"
                  :data-min="data_inicial"
                  @set="handleDataFilter()"
                />
              </v-col>
            </template>
            <template v-slot:[`item.status`]="{ item }">
              <v-chip
                :color="colorStatus(item.status)"
                small
                class="mb-2 pl-4 pr-4 my-1"
              >
                {{ item.status }}
              </v-chip>
            </template>
          </crud-list>
          <data-dialog />
        </div>
      </v-card>
    </template>
  </div>
</template>
<script>
  import LogsStore, { BOOTSTRAP, LOAD_DETALHES } from '@/store/modules/logs'
  import { mapState, mapActions } from 'vuex'
  import { StatusLog } from '../../utils/constants'
  import DataDialog from './DataDialog'
  import moment from 'moment'

  export default {
    name: 'Logs',

    components: {
      DataDialog,
    },

    data () {
      return {
        actions: [
          {
            title: 'Visualizar',
            color: 'info darken-3',
            click: item => this.handleLoadDetalhes(item),
            icon: 'mdi-eye',
          },
        ],
        headers: [
          { text: '', value: 'actions', sortable: false, groupable: false, width: '20px' },
          { align: 'center', text: 'Data', value: 'logged_at', sortable: true, groupable: false, floatingfilter: false, report: true },
          { align: 'left', text: 'Usuário', value: 'nomeUsuario', sortable: true, groupable: true, floatingfilter: true, report: true },
          { align: 'left', text: 'Perfil', value: 'role', sortable: true, groupable: true, floatingfilter: true, report: true, subProperty: ['roles', 0, 'description'] },
          { align: 'left', text: 'Plataforma', value: 'platform', sortable: true, groupable: true, floatingfilter: true, report: true },
          { align: 'center', text: 'Versão', value: 'version', sortable: true, groupable: true, floatingfilter: true, report: true },
          { align: 'left', text: 'Status', value: 'status', sortable: true, groupable: true, floatingfilter: true, report: true },
        ],
        data_inicial: 'from',
        data_final: 'to',
      }
    },

    computed: {
      ...mapState('logs', ['logs', 'loading']),
    },

    created () {
      if (!this.$store.hasModule('logs')) { this.$store.registerModule('logs', LogsStore) }

      this.data_inicial = moment().startOf('month').format('YYYY-MM-DD')
      this.data_final = moment().endOf('month').format('YYYY-MM-DD')

      this.BOOTSTRAP({ data_inicial: this.data_inicial, data_final: this.data_final })
    },

    methods: {
      ...mapActions('logs', [BOOTSTRAP, LOAD_DETALHES]),

      itemRowBackground: function (item) {
        if (item.status === StatusLog.FINALIZADO) {
          return 'green lighten-5'
        } else if (item.status === StatusLog.CANCELADO || item.status === StatusLog.ERROR) {
          return 'red lighten-5'
        } else if (item.status === StatusLog.EM_ANDAMENTO) {
          return 'yellow lighten-5'
        }
      },

      colorStatus (status) {
        if (status === StatusLog.FINALIZADO) {
          return 'success'
        } else if (status === StatusLog.CANCELADO || status === StatusLog.ERROR) {
          return 'error'
        } else if (status === StatusLog.EM_ANDAMENTO) {
          return 'warning'
        }
      },

      handleDataFilter () {
        this.BOOTSTRAP({ data_inicial: this.data_inicial, data_final: this.data_final })
      },

      handleLoadDetalhes (item) {
        const parametrs = {
          logged_at: item.logged_at,
          user_id: item.user_id,
          version: item.version,
          status: item.status,
        }
        this.LOAD_DETALHES(parametrs)
      },
    },
  }
</script>
